import { GraphicElement } from '../entities/Drawable/GraphicElement';

/**
 * Cloner - Deep copy d'éléments GraphicElement
 * REF: config3D-sandbox/src/Domain/Cloner.ts
 */
export class Cloner {
    /**
     * Exécute un deep copy d'un GraphicElement
     * Utilise JSON serialization pour copier toutes les propriétés
     */
    public static execute(obj: GraphicElement): GraphicElement {
        console.log('🔬 Cloner.execute called:', {
            type: obj.type,
            uuid: obj.uuid?.substring(0, 8)
        });

        try {
            // Deep copy via JSON
            // On censure Engine pour éviter les références circulaires
            const jsonString = JSON.stringify(obj, (key, value) => {
                // Censurer Engine pour éviter circular reference
                if (key === '_engine' || key === 'engine') {
                    return '[Engine]';
                }
                return value;
            });

            console.log('🔬 Cloner: JSON serialized, length:', jsonString.length);

            // Parse et recréer l'objet
            const cloned = JSON.parse(jsonString);

            // Restaurer les références Engine
            cloned._engine = obj._engine;
            if (cloned.transform) {
                cloned.transform._engine = obj._engine;
            }

            // Générer un nouveau UUID
            cloned._uuid = GraphicElement.generateUUID();

            console.log('🔬 Cloner.execute result:', {
                originalUuid: obj.uuid?.substring(0, 8),
                clonedUuid: cloned._uuid?.substring(0, 8),
                type: cloned.type,
                hasTransform: !!cloned.transform,
                hasContent: !!cloned._content
            });

            return cloned;
        } catch (error) {
            console.error('🔬 Cloner.execute FAILED:', error);
            throw error;
        }
    }
}
